import React, { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import { Link as ScrollLink } from "react-scroll";
import StickyIcon from "./StickyIcon";

const Header = () => {
  const [isOpen, setIsOpen] = useState(false);

  const toggleMenu = () => setIsOpen(!isOpen);
  const closeMenu = () => setIsOpen(false);

  const navLinks = [
    { to: "section2", label: "Acerca de" },
    { to: "section3", label: "Servicios" },
    { to: "section4", label: "¿Cómo funciona?" },
  ];

  return (
    <header className="bg-white shadow-sm border-b border-gray-100 relative">
      <div className="max-w-6xl mx-auto px-4 flex items-center justify-between h-16">
        <RouterLink to="/" className="flex items-center" onClick={closeMenu}>
          <picture>
            <source srcSet="/logo2.webp" type="image/webp" />
            <img
              src="/logo2.png"
              alt="Master Mop Limpieza Profunda"
              className="h-12 w-12"
            />
          </picture>
        </RouterLink>

        {/* Desktop nav */}
        <nav className="hidden md:flex items-center gap-1">
          {navLinks.map(({ to, label }) => (
            <ScrollLink
              key={to}
              to={to}
              smooth={true}
              duration={500}
              className="cursor-pointer text-gray-600 hover:text-orange-500 px-3 py-2 rounded-md text-sm font-medium transition-colors"
            >
              {label}
            </ScrollLink>
          ))}
          <a
            href="https://wa.me/message/WNVVW57KVZGPP1?src=qr"
            target="_blank"
            rel="noopener noreferrer"
            className="ml-3 bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2 rounded-full transition-colors"
          >
            Cotiza ahora
          </a>
        </nav>

        {/* Mobile hamburger */}
        <button
          onClick={toggleMenu}
          className="md:hidden text-gray-600 hover:text-orange-500 focus:outline-none p-1"
          aria-label="Abrir menú"
        >
          {isOpen ? (
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M6 18L18 6M6 6l12 12" />
            </svg>
          ) : (
            <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M4 6h16M4 12h16m-7 6h7" />
            </svg>
          )}
        </button>
      </div>

      {/* Mobile dropdown */}
      {isOpen && (
        <div className="md:hidden absolute top-full left-0 right-0 bg-white shadow-lg border-t border-gray-100 z-50 flex flex-col py-2">
          {navLinks.map(({ to, label }) => (
            <ScrollLink
              key={to}
              to={to}
              smooth={true}
              duration={500}
              className="cursor-pointer text-gray-600 hover:text-orange-500 hover:bg-gray-50 px-5 py-3 text-sm font-medium transition-colors"
              onClick={closeMenu}
            >
              {label}
            </ScrollLink>
          ))}
          <div className="px-5 py-3">
            <a
              href="https://wa.me/message/WNVVW57KVZGPP1?src=qr"
              target="_blank"
              rel="noopener noreferrer"
              className="block bg-orange-500 hover:bg-orange-600 text-white text-sm font-semibold px-4 py-2 rounded-full text-center transition-colors"
              onClick={closeMenu}
            >
              Cotiza ahora
            </a>
          </div>
        </div>
      )}

      <StickyIcon />
    </header>
  );
};

export default Header;
